import React, { useState, useEffect, useRef, useMemo } from "react";
import config from "../../common/Config";
import ExportProductList from "./ExportProductList";
import { checkProductInActivePromotions } from "../../../utils/promotionCache";
import { Box, TableContainer, TablePagination, Typography, Paper, IconButton, Menu, MenuItem, alpha, InputAdornment, TextField, Grid2, GlobalStyles, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Alert, Snackbar, RadioGroup, Radio, FormControlLabel, FormControl, TableHead, Table, TableRow, TableCell, TableBody, Link, Checkbox } from "@mui/material";
import LastPageDoubleArrowIcon from "../../common/LastPageDoubleArrowIcon";
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import { useTheme } from '@mui/material/styles';
import { toast } from "sonner";
import StandaloneManageColumnsModal from "../../tableComponents/manageColumns/StandaloneManageColumnsModal";
import Edit_Product from "./Edit_Product";
import ProductPriceInlineCell, { EDITABLE_PRICE_COLUMNS } from "./ProductPriceInlineCell";
import '../../common/commonStyles.css';
import { encryptPayload, resolveEncryptedResponse } from "../../../utils/customerCrypto";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../../../utils/companySettingsCache";

import { ProductSearchInput } from '../../../productSearch/ProductSearchInput';
import { normalizeProductSearchApiRoot } from '../../../utils/productSearchUrls';
import { tokenize } from '../../../productSearch/tokenizer';
import { isPackSizeLikeToken } from '../../../productSearch/matchProductTokens';

const isAtrPrefix = config.PREFIX === "atr";
const columnVisibilityStorageKey = isAtrPrefix
  ? "activeProductListColumnVisibilityV2"
  : "activeProductListColumnVisibility";

const tableColumns = isAtrPrefix
  ? [
      { id: "code", label: "Code", numeric: false, width: 80 },
      { id: "name", label: "Name", numeric: false, width: 230 },
      { id: "categories", label: "Category", numeric: false, width: 160 },
      { id: "brand", label: "Brand", numeric: false, width: 120 },
      { id: "size", label: "Size", numeric: false, width: 90 },
      { id: "quantity", label: "B.Qty", numeric: true, width: 55 },
      { id: "split_quantity", label: "P.Qty", numeric: true, width: 50 },
      { id: "box_cost", label: "B.Cost P", numeric: true, width: 60 },
      { id: "price", label: "B.Sale P", numeric: true, width: 70 },
      { id: "box_diff", label: "B.Profit %", numeric: true, width: 60 },
      { id: "piece_cost", label: "P.Cost P", numeric: true, width: 60 },
      { id: "piece_price", label: "P.Sale P", numeric: true, width: 70 },
      { id: "piece_diff", label: "P.Profit %", numeric: true, width: 60 },
      { id: "action", label: "Action", numeric: false, width: 60 },
    ]
  : [
      { id: "code", label: "Code", numeric: false, width: 80 },
      { id: "name", label: "Name", numeric: false, width: 230 },
      { id: "categories", label: "Category", numeric: false, width: 160 },
      { id: "brand", label: "Brand", numeric: false, width: 120 },
      { id: "size", label: "Size", numeric: false, width: 90 },
      { id: "box_cost", label: "B.Cost P", numeric: true, width: 60 },
      { id: "price", label: "B.Sale P", numeric: true, width: 70 },
      { id: "box_diff", label: "B.Profit %", numeric: true, width: 60 },
      { id: "quantity", label: "B.Qty", numeric: true, width: 50 },
      { id: "piece_cost", label: "P.Cost P", numeric: true, width: 60 },
      { id: "piece_price", label: "P.Sale P", numeric: true, width: 70 },
      { id: "piece_diff", label: "P.Profit %", numeric: true, width: 60 },
      { id: "split_quantity", label: "P.Qty", numeric: true, width: 50 },
      { id: "action", label: "Action", numeric: false, width: 60 },
    ];

const ActiveProductList = ({ refresh, selectedIds = [], setSelectedIds }) => {
  const showTscCheckbox = config.PREFIX === "tsc" && typeof setSelectedIds === "function";
  const theme = useTheme();
  const activePdtRef = useRef(null);
  const searchFieldRef = useRef("code");
  const [searchValue, setSearchValue] = useState("");
  const [searchField, setSearchField] = useState("code");
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [totalActiveProduct, setTotalActiveProduct] = useState("");
  const [totalboxProduct, setTotalboxProduct] = useState("");
  const [totalpieceProduct, setTotalpieceProduct] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [menuAnchor, setMenuAnchor] = useState({ el: null, row: null });
  const [confirmDialog, setConfirmDialog] = useState({ open: false, title: '', message: '', onConfirm: null });
  const [errorDialog, setErrorDialog] = useState({ open: false, title: '', message: '' });
  const [successSnackbar, setSuccessSnackbar] = useState({ open: false, message: '' });
  const [editProductDialog, setEditProductDialog] = useState({ open: false, row: null });
  const [editProductForm, setEditProductForm] = useState({ code: "", name: "", price: "", specialPrice: "", telly: "", cashAndCarrySales: "", website: "" });
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [editPopupProductId, setEditPopupProductId] = useState(null);
  const [editPopupDynamic, setEditPopupDynamic] = useState(false);
  const [activePdtList, setActivePdtList] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState(() => {
    try {
      const saved = localStorage.getItem(columnVisibilityStorageKey);
      if (saved) {
        const parsed = JSON.parse(saved);
        const visibility = {};
        tableColumns.forEach((_, idx) => {
          visibility[idx] = parsed[idx] !== false;
        });
        return visibility;
      }
    } catch (_) { }
    const visibility = {};
    tableColumns.forEach((_, idx) => {
      visibility[idx] = true;
    });
    return visibility;
  });
  const [hoveredHeader, setHoveredHeader] = useState(null);
  const [isManageColumnsOpen, setIsManageColumnsOpen] = useState(false);
  const manageColumnsConfig = useMemo(() => tableColumns.map((col) => ({ header: col.label })), []);
  const visibleColumns = useMemo(
    () =>
      tableColumns
        .map((column, index) => ({ column, index }))
        .filter(({ index }) => columnVisibility[index] !== false),
    [columnVisibility]
  );

  const productSearchApiBase = useMemo(
    () => normalizeProductSearchApiRoot(config.API_URL),
    []
  );

  const fetchActiveProducts = async () => {
    const start = page * rowsPerPage;
    const apiColumns = tableColumns.filter((c) => c.id !== "action").map((c) => c.id);
    const searchFieldVal = searchFieldRef.current || "name";
    const searchTrim = String(searchValue || "").trim();
    const searchTokens = tokenize(searchTrim);
    let effectiveSearchField = searchFieldVal;
    if (
      effectiveSearchField === "code" &&
      searchTokens.length === 1 &&
      isPackSizeLikeToken(searchTokens[0])
    ) {
      effectiveSearchField = "name";
    }
    const authHeader = `Bearer ${token || accessToken}`;
    try {
      const settings = await getCompanySettings();
      const useEncrypt = resolveCustomerApiEncrypt(settings);
      let body;
      const headers = { authorization: authHeader };
      if (useEncrypt) {
        const requestData = {
          draw: 1,
          start,
          length: rowsPerPage,
          searchValue: searchValue || "",
          searchField: effectiveSearchField,
          categoryValue: 0,
        };
        const encryptedPayload = encryptPayload(requestData);
        if (!encryptedPayload) {
          setActivePdtList([]);
          return;
        }
        const formData = new FormData();
        formData.append("encrypted_payload", encryptedPayload);
        body = formData;
      } else {
        const params = new URLSearchParams();
        params.append("draw", "1");
        params.append("start", String(start));
        params.append("length", String(rowsPerPage));
        params.append("searchValue", searchValue || "");
        params.append("searchField", effectiveSearchField);
        params.append("search[value]", searchValue || "");
        params.append("search[regex]", "false");
        params.append("categoryValue", "0");
        apiColumns.forEach((col, index) => {
          params.append(`columns[${index}][data]`, col);
          params.append(`columns[${index}][name]`, "");
          params.append(`columns[${index}][searchable]`, "true");
          params.append(`columns[${index}][orderable]`, "false");
          params.append(`columns[${index}][search][value]`, "");
          params.append(`columns[${index}][search][regex]`, "false");
        });
        body = params.toString();
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      const response = await fetch(`${config.API_URL}/products/getactive_product`, {
        method: "POST",
        headers,
        body,
      });
      const json = await response.json();
      const decrypted = useEncrypt ? resolveEncryptedResponse(json) : null;
      const resolved =
        useEncrypt && decrypted && typeof decrypted === "object" ? decrypted : json;
      if (resolved && Array.isArray(resolved.data)) {
        setActivePdtList(resolved.data);
        setTotalActiveProduct(resolved.recordsFiltered ?? resolved.data.length);
        setTotalboxProduct(resolved.box_amount_total ?? "");
        setTotalpieceProduct(resolved.piece_amount_total ?? "");
      } else {
        setActivePdtList([]);
      }
    } catch (e) {
      setActivePdtList([]);
    }
  };

  useEffect(() => {
    searchFieldRef.current = searchField;
  }, [searchField]);

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    if (!refresh) return;
    fetchActiveProducts();
  }, [refresh, page, rowsPerPage]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (refresh) fetchActiveProducts();
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [searchValue, searchField]);


  const handleMenuClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setMenuAnchor({ el: null, row: null });
  };

  const handleMenuAction = async (action, row) => {
    handleMenuClose();

    if (action === 'toggle-status') {
      const currentStatus = row.status;
      const newStatus = currentStatus == "0" ? "1" : "0";
      const statusLabel = newStatus == "1" ? "activate" : "Inactivate";

      if (newStatus == "0") {
        const promotionCheck = await checkProductInActivePromotions(row.id, accessToken);
        if (promotionCheck.hasActivePromotions) {
          const promotions = promotionCheck.promotions;
          const promotionIds = promotions
            .map(p => p.id || p.promotion_id)
            .filter(Boolean)
            .join(', ');

          const getPromotionTypeLabel = (type) => {
            const typeMap = {
              'buy-x-get-y-free': 'Buy X Get Y Free',
              'buy-x-get-y-discount': 'Buy X Get Y Discount',
              'buy-x-discount': 'Buy X Discount',
              'multi-layer-offer': 'Multi-Layer Offer'
            };
            return typeMap[type] || 'Promotion';
          };

          const promotionTypes = [...new Set(promotions.map(p => p.type || p.promotion_type).filter(Boolean))];
          const typeLabels = promotionTypes.map(getPromotionTypeLabel);

          let message = '';
          if (promotionTypes.length === 1 && promotionTypes[0] === 'buy-x-get-y-free') {
            message = `This product is part of an active 'Buy X Get Y Free' promotion (ID: ${promotionIds}). To inactivate this product, please deactivate the promotion first.`;
          } else if (promotionTypes.length === 1) {
            message = `This product is part of an active '${typeLabels[0]}' promotion (ID: ${promotionIds}). To inactivate this product, please deactivate the promotion first.`;
          } else {
            const typesText = typeLabels.join("', '");
            message = `This product is part of active promotions ('${typesText}') with IDs: ${promotionIds}. To inactivate this product, please deactivate these promotions first.`;
          }

          setErrorDialog({
            open: true,
            title: "Cannot Mark Product as Inactive",
            message: message
          });
          return;
        }
      }

      setConfirmDialog({
        open: true,
        title: "Are you sure?",
        message: `Do you want to ${statusLabel} this product?`,
        onConfirm: () => {
          handleChangeStatus(row.id, newStatus);
          setConfirmDialog({ open: false, title: '', message: '', onConfirm: null });
        }
      });
    } else if (action === 'edit' || action === 'edit-dynamic') {
      const myId = String(userId ?? "").trim();
      const openedId = String(row?.opened_id ?? "").trim();
      const isOpenByAnotherUser =
        Number(row?.is_open) === 1 &&
        openedId !== "" &&
        openedId !== myId;
      if (isOpenByAnotherUser) {
        const who = row?.opened_by != null && String(row.opened_by).trim() !== "" ? String(row.opened_by).trim() : "another user";
        toast.error(`This product is opened by: ${who}`);
        return;
      }
      setEditPopupDynamic(action === 'edit-dynamic');
      setEditPopupProductId(row.id);
      setEditPopupOpen(true);
    } else if (action === 'previous-pricing') {
      window.location.href = `${config.BASE_URL}/products/previous_pricing/${row.id}`;
    } else if (action === 'print-sticker') {
      window.open(`${config.BASE_URL}/product/price_sticker/${row.id}`, '_blank');
    } else if (action === 'add-to-shopify') {
    }
  };

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();
    formData.append("productId", id);
    formData.append("status", status);
    const apiUrl = `${config.API_URL}/products/update_status`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to change status");
      }
      await response.json();
      setSuccessSnackbar({
        open: true,
        message: "Status changed successfully."
      });
      fetchActiveProducts();
    } catch (error) {
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleColumnVisibilityChange = (visibility) => {
    setColumnVisibility(visibility);
    try {
      localStorage.setItem(columnVisibilityStorageKey, JSON.stringify(visibility));
    } catch (_) { }
  };


  const handleEditProduct = (row) => {
    setEditPopupProductId(row.id);
    setEditPopupOpen(true);
  };

  const handleOpenSpecialPriceDialog = (row) => {
    // setEditProductDialog({ open: accessToken == "dan" ? true : false, row });
    setEditProductDialog({ open: false, row });
    setEditProductForm({
      code: row.code || "",
      telly: row.telly ?? "",
      cashAndCarrySales: row.cash_and_carry_sales ?? "",
      website: row.website ?? ""
    });
  };

  const handleCloseEditPopup = () => {
    setEditPopupOpen(false);
    setEditPopupProductId(null);
    setEditPopupDynamic(false);
    fetchActiveProducts();
  };

  const handleCloseEditProductDialog = () => {
    setEditProductDialog({ open: false, row: null });
  };

  const menuItems = {
    py: 1,
    px: 1.5,
    borderRadius: 1,
    gap: 1.5
  }

  const menuItemText = {
    fontWeight: 400,
    color: '#212b36',
    fontSize: '0.875rem'
  }

  return (
    <>
      <GlobalStyles
        styles={{
          '#activePdtListTable': {
            borderCollapse: 'separate',
            borderSpacing: 0,
            tableLayout: 'fixed'
          },
          '#activePdtListTable th': {
            fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            padding: '4px 12px',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: '#212b36 !important',
            backgroundColor: '#EAEAEA',
            borderBottom: '1px dashed rgba(145, 158, 171, 0.06)',
            borderLeft: 'none',
            borderRight: 'none',
            userSelect: 'none',
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            verticalAlign: 'middle'
          },
          '#activePdtListTable td': {
            fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            padding: '7px 16px',
            fontSize: '0.75rem',
            color: '#1c252e!important',
            borderBottom: '1px dashed #c4c4c4',
            borderLeft: 'none',
            borderRight: 'none',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            verticalAlign: 'middle',
            backgroundColor: 'transparent'
          },
          '#activePdtListTable tbody tr:hover td': {
            backgroundColor: '#F9FAFB !important'
          },
          '#activePdtListTable tbody tr:last-child td': {
            borderBottom: 'none'
          },

          '#activePdtListTable th.headerMain': {
            padding: '8px 12px !important',
          },
          '#activePdtListTable td[data-column-id="quantity"], #activePdtListTable td[data-column-id="split_quantity"], #activePdtListTable td[data-column-id="box_cost"], #activePdtListTable td[data-column-id="price"], #activePdtListTable td[data-column-id="box_diff"], #activePdtListTable td[data-column-id="piece_cost"], #activePdtListTable td[data-column-id="piece_price"], #activePdtListTable td[data-column-id="piece_diff"]': {
            textAlign: 'right'
          },
          ...(isAtrPrefix
            ? {
                '#activePdtListTable td[data-column-id="box_cost"], #activePdtListTable td[data-column-id="price"], #activePdtListTable td[data-column-id="box_diff"], #activePdtListTable td[data-column-id="piece_cost"], #activePdtListTable td[data-column-id="piece_price"], #activePdtListTable td[data-column-id="piece_diff"]': {
                  backgroundColor: '#f8f4f48f'
                },
                '#activePdtListTable tbody tr:hover td[data-column-id="box_cost"], #activePdtListTable tbody tr:hover td[data-column-id="price"], #activePdtListTable tbody tr:hover td[data-column-id="box_diff"], #activePdtListTable tbody tr:hover td[data-column-id="piece_cost"], #activePdtListTable tbody tr:hover td[data-column-id="piece_price"], #activePdtListTable tbody tr:hover td[data-column-id="piece_diff"]': {
                  backgroundColor: '#F9FAFB !important'
                },
                '#activePdtListTable td[data-column-id="box_cost"], #activePdtListTable th[data-column-id="box_cost"], #activePdtListTable td[data-column-id="piece_cost"], #activePdtListTable th[data-column-id="piece_cost"]': {
                  borderLeft: '1px dashed rgba(4, 6, 7, 0.24)'
                },
              }
            : {
                '#activePdtListTable td[data-column-id="box_cost"], #activePdtListTable td[data-column-id="price"], #activePdtListTable td[data-column-id="box_diff"], #activePdtListTable td[data-column-id="quantity"], #activePdtListTable td[data-column-id="piece_cost"], #activePdtListTable td[data-column-id="piece_price"], #activePdtListTable td[data-column-id="piece_diff"], #activePdtListTable td[data-column-id="split_quantity"]': {
                  backgroundColor: '#f8f4f48f'
                },
                '#activePdtListTable tbody tr:hover td[data-column-id="box_cost"], #activePdtListTable tbody tr:hover td[data-column-id="price"], #activePdtListTable tbody tr:hover td[data-column-id="box_diff"], #activePdtListTable tbody tr:hover td[data-column-id="quantity"], #activePdtListTable tbody tr:hover td[data-column-id="piece_cost"], #activePdtListTable tbody tr:hover td[data-column-id="piece_price"], #activePdtListTable tbody tr:hover td[data-column-id="piece_diff"], #activePdtListTable tbody tr:hover td[data-column-id="split_quantity"]': {
                  backgroundColor: '#F9FAFB !important'
                },
                '#activePdtListTable td[data-column-id="piece_cost"], #activePdtListTable th[data-column-id="piece_cost"]': {
                  borderLeft: '1px dashed rgba(4, 6, 7, 0.24)'
                },
              }),
        }}
      />

      <Grid2 container spacing={2} sx={{ pb: 1, px: 2 }} alignItems="center">
        <Grid2 size={{ xs: 12, md: 6 }}>

          {/* <ProductSearchInput
            apiBaseUrl={productSearchApiBase}
            token={token || accessToken}
            tenantId={String(config.PREFIX || "default")}
            onSelect={(p) => {
              searchFieldRef.current = "code";  
              setSearchField("code");
              setSearchValue(p.code || "");
            }}
          /> */}
          <Typography variant="body2" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' }, fontWeight: 500, color: '#212b36', wordBreak: 'break-word' }}>
            <b>Stock Value Box:</b> {totalboxProduct} | <b>Stock Value Piece:</b> {totalpieceProduct} | <b>Total Stock Value:</b> {(Number(totalboxProduct) + Number(totalpieceProduct)).toFixed(2)}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: { xs: 'flex-start', md: "end" }, alignItems: { xs: 'stretch', sm: "center" }, gap:1}}>
            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: "center" }, gap: { xs: 1.5, sm: 2 }, width: { xs: '100%', sm: 'auto' } }}>
              <FormControl component="fieldset" sx={{ width: { xs: '100%', sm: 'auto' } }}>
                <RadioGroup
                  row
                  value={searchField}
                  className="checkBox"
                  onChange={(e) => {
                    searchFieldRef.current = e.target.value;
                    setSearchField(e.target.value);
                  }}
                  sx={{
                    gap: { xs: 0.5, sm: 1 },
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    "& .MuiFormControlLabel-root": {
                      margin: 0,
                    },
                    "& .MuiRadio-root": {
                      padding: "4px",
                      color: "#212b36",

                    },
                    "& .MuiFormControlLabel-label": {
                      fontSize: { xs: "0.75rem", sm: "0.75rem" },
                      color: "#212121",
                      fontWeight: 400,
                    },
                  }}
                >
                  <FormControlLabel value="code" control={<Radio size="small" />} label="Code" />
                  <FormControlLabel value="name" control={<Radio size="small" />} label="Name" />
                  <FormControlLabel value="category" control={<Radio size="small" />} label="Category" />
                  <FormControlLabel value="brand" control={<Radio size="small" />} label="Brand" />
                </RadioGroup>
              </FormControl>
              <TextField
                className="input-border"
                label="Search"
                variant="outlined"
                size="small"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && refresh) fetchActiveProducts();
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Iconify icon="eva:search-fill"/>
                    </InputAdornment>
                  ),
                }}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <ExportProductList totalActiveProduct={totalActiveProduct} urlLink="products/getactive_product" pdtStatus="active" token={token} />
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      <Paper>
        <TableContainer
          sx={{
            overflowX: 'auto',
            position: 'relative',
            minHeight: visibleColumns.length === 0 ? 320 : undefined,
          }}
        >
          {visibleColumns.length === 0 && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  backgroundColor: '#fff',
                  padding: 3,
                  borderRadius: 2,
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                  border: '1px solid rgba(145, 158, 171, 0.24)',
                  minWidth: 280
                }}
              >
                <Iconify icon="eva:eye-off-outline" width={48} height={48} sx={{ color: '#637381', mb: 1.5 }} />
                <Typography variant="h6" sx={{ mb: 1, color: '#212b36', fontSize: '1rem', fontWeight: 600 }}>
                  All Columns Hidden
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#637381', mb: 2 }}>
                  All table columns are currently hidden. Click below to manage column visibility.
                </Typography>
                <Button
                  variant="contained"
                  className="button-variant-contained"
                  onClick={() => setIsManageColumnsOpen(true)}
                  startIcon={<Iconify icon="mdi:cog" width={18} height={18} />}
                >
                  Manage Columns
                </Button>
              </Box>
            </Box>
          )}
          <Table
            id="activePdtListTable"
            ref={activePdtRef}
            className="table table-hover table-sm"
            sx={{ opacity: visibleColumns.length === 0 ? 0.3 : 1 }}
          >
            <TableHead
              className="table-cell-border"
              sx={{
                '& .headerSub': {
                  backgroundColor: '#d3d9de !important',
                  borderBottom: '1px dashed #c4c4c4 !important',
                  padding: '8px 4px !important',
                },
              }}
            >
              <TableRow>
                {showTscCheckbox && (
                  <TableCell className="headerMain" sx={{ width: 45, minWidth: 45 }} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                      className="checkBox"
                      size="small"
                      checked={activePdtList.length > 0 && activePdtList.every((r) => selectedIds.some((id) => id == r.id))}
                      indeterminate={activePdtList.some((r) => selectedIds.some((id) => id == r.id)) && !activePdtList.every((r) => selectedIds.some((id) => id == r.id))}
                      onChange={(e) => {
                        e.stopPropagation();
                        const pageIds = activePdtList.map((r) => r.id);
                        if (e.target.checked) {
                          setSelectedIds((prev) => [...new Set([...prev, ...pageIds])]);
                        } else {
                          setSelectedIds((prev) => prev.filter((id) => !pageIds.some((pid) => pid == id)));
                        }
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </TableCell>
                )}
                {visibleColumns.map(({ column, index }) => {
                  const isNumeric = column.numeric;
                  const isHovered = hoveredHeader === index;
                  return (
                    <TableCell
                      key={column.id}
                      data-column-id={column.id}
                      className={column.id === 'action' || (isAtrPrefix && (column.id === 'quantity' || column.id === 'split_quantity')) ? 'headerMain' : isNumeric ? 'headerSub' : 'headerMain'}
                      align={isNumeric ? 'right' : 'left'}
                      style={{ width: column.width }}
                      sx={{
                        position: 'relative',
                        pr: isHovered ? 4.5 : 2,
                      }}
                      onMouseEnter={() => setHoveredHeader(index)}
                      onMouseLeave={() => setHoveredHeader((prev) => (prev === index ? null : prev))}
                    >
                      {!(isNumeric && isHovered) && column.label}
                      {isHovered && (
                        <IconButton
                          size="small"
                          sx={{ position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsManageColumnsOpen(true);
                          }}
                        >
                          <Iconify icon="mdi:dots-horizontal" width={16} height={16} />
                        </IconButton>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {activePdtList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={visibleColumns.length + (showTscCheckbox ? 1 : 0)} sx={{ py: 4 }}>
                    <Typography align="center" sx={{ color: '#637381', fontSize: '0.75rem' }}>
                      No records found.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                activePdtList.map((row) => {
                  const shortCode = row.code && row.code.length > 8 ? `${row.code.substring(0, 8)}…` : (row.code || '');
                  return (
                    <TableRow key={row.id}>
                      {showTscCheckbox && (
                        <TableCell sx={{ width: 50, minWidth: 50 }} onClick={(e) => e.stopPropagation()}>
                          <Checkbox
                            className="checkBox"
                            size="small"
                            checked={selectedIds.some((id) => id == row.id)}
                            onChange={(e) => {
                              e.stopPropagation();
                              const id = row.id;
                              if (e.target.checked) {
                                setSelectedIds((prev) => (prev.some((i) => i == id) ? prev : [...prev, id]));
                              } else {
                                setSelectedIds((prev) => prev.filter((i) => i != id));
                              }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </TableCell>
                      )}
                      {visibleColumns.map(({ column }) => {
                        const isNumeric = column.numeric;
                        if (column.id === 'code') {
                          return (
                            <TableCell key={column.id} align={isNumeric ? 'right' : 'left'}>
                              {/* <Link
                              component="button"
                              sx={{ color: '#212b36', textDecoration: 'underline', cursor: 'pointer' }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpenSpecialPriceDialog(row);
                              }}
                              title={row.code}
                            >
                              {shortCode}
                            </Link> */}
                              {shortCode}
                            </TableCell>
                          );
                        }
                        if (column.id === 'action') {
                          return (
                            <TableCell key={column.id} data-column-id={column.id} align="left">
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setMenuAnchor({ el: e.currentTarget, row });
                                  }}
                                  sx={{ color: '#637381' }}
                                >
                                  <Iconify icon="eva:more-vertical-fill" width={18} />
                                </IconButton>
                              </Box>
                            </TableCell>
                          );
                        }
                        const value = row[column.id];
                        if (isAtrPrefix && EDITABLE_PRICE_COLUMNS.includes(column.id)) {
                          return (
                            <ProductPriceInlineCell
                              key={column.id}
                              row={row}
                              columnId={column.id}
                              value={value}
                              align={isNumeric ? 'right' : 'left'}
                              onSaved={(updates) => {
                                setActivePdtList((prev) =>
                                  prev.map((r) => (r.id == row.id ? { ...r, ...updates } : r))
                                );
                              }}
                            />
                          );
                        }
                        return (
                          <TableCell
                            key={column.id}
                            data-column-id={column.id}
                            align={isNumeric ? 'right' : 'left'}
                          >
                            {value ?? ''}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={Number(totalActiveProduct) || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          labelRowsPerPage="Rows per page:"
          showLastButton
          slots={{ actions: { lastButtonIcon: LastPageDoubleArrowIcon } }}
          className="pagination-styles"
        />
      </Paper>

      <Menu
        anchorEl={menuAnchor.el}
        open={Boolean(menuAnchor.el)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          onClick: (e) => e.stopPropagation(),
          sx: {
            minWidth: 160,
            borderRadius: 1.5,
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
            p: 0.5,
          },
        }}
      >
        {menuAnchor.row && (
          <>
            <MenuItem
              onClick={() => handleMenuAction('toggle-status', menuAnchor.row)}
              sx={{
                ...menuItems,
                color: menuAnchor.row.status == "1" ? "#FF5630" : "#22C55E",
              }}
            >
              <Iconify
                icon="tabler:toggle-right-filled"
                width={20}
                sx={{ color: menuAnchor.row.status == "1" ? "#FF5630" : "#22C55E" }}
              />
              <Typography
                sx={{
                  ...menuItemText,
                  color: menuAnchor.row.status == "1" ? "#FF5630 !important" : "#22C55E !important",
                  fontWeight: 600,
                }}
              >
                {menuAnchor.row.status == "1" ? "Mark Inactive" : "Mark Active"}
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('edit', menuAnchor.row)} sx={menuItems}>
              <Iconify icon="fa-regular:edit" width={18} sx={{ color: 'text.secondary' }} />
              <Typography sx={menuItemText}>Edit</Typography>
            </MenuItem>
            {(config.PREFIX === "ebu" || accessToken === "ebu" || config.PREFIX === "rhp" || accessToken === "rhp") && (
            <MenuItem onClick={() => handleMenuAction('edit-dynamic', menuAnchor.row)} sx={menuItems}>
              <Iconify icon="fa-regular:edit" width={18} sx={{ color: 'text.secondary' }} />
              <Typography sx={menuItemText}>Edit Dynamic</Typography>
            </MenuItem>
            )}
            <MenuItem onClick={() => handleMenuAction('previous-pricing', menuAnchor.row)} sx={menuItems}>
              <Iconify icon="bi:tags" width={18} sx={{ color: 'text.secondary' }} />
              <Typography sx={menuItemText}>Product History</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction('print-sticker', menuAnchor.row)} sx={menuItems}>
              <Iconify icon="material-symbols:print-outline" width={20} sx={{ color: 'text.secondary' }} />
              <Typography sx={menuItemText}>Print Sticker</Typography>
            </MenuItem>
          </>
        )}
      </Menu>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, title: '', message: '', onConfirm: null })}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          {confirmDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialog({ open: false, title: '', message: '', onConfirm: null })}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDialog.onConfirm || (() => { })}

            variant="contained"
            autoFocus
            sx={{
              backgroundColor: "#F8991D",
              "&:hover": {
                backgroundColor: "#F8991D",
                boxShadow: "none",
              },

            }}
          >
            Yes, change it!
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Dialog */}
      <Dialog
        open={errorDialog.open}
        onClose={() => setErrorDialog({ open: false, title: '', message: '' })}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title" sx={{ color: 'error.main' }}>
          {errorDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description" component="div">
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorDialog.message}
            </Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setErrorDialog({ open: false, title: '', message: '' })}
            color="primary"
            variant="contained"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Edit_Product
        productId={editPopupProductId}
        open={editPopupOpen}
        onClose={handleCloseEditPopup}
        onSuccess={handleCloseEditPopup}
        useDynamicForm={editPopupDynamic}
      />

      <Dialog
        open={editProductDialog.open}
        onClose={handleCloseEditProductDialog}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 1.5 } }}
      >
        <DialogTitle>Special Price</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", gap: 1 }}>
              <TextField
                className="form-input-border"
                label="Code"
                placeholder="Code"
                value={editProductForm.code}
                onChange={(e) => setEditProductForm((prev) => ({ ...prev, code: e.target.value }))}
                fullWidth
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", gap: 1 }}>
              <TextField
                className="form-input-border"
                label="Telly"
                placeholder="Special Price"
                value={editProductForm.telly}
                onChange={(e) => setEditProductForm((prev) => ({ ...prev, price: e.target.value }))}
                fullWidth
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", gap: 1 }}>
              <TextField
                className="form-input-border"
                label="Cash and Carry Sales"
                placeholder="Special Price"
                value={editProductForm.cashAndCarrySales}
                onChange={(e) => setEditProductForm((prev) => ({ ...prev, specialPrice: e.target.value }))}
                fullWidth
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", gap: 1 }}>
              <TextField
                className="form-input-border"
                label="Website"
                placeholder="Special Price"
                value={editProductForm.website}
                onChange={(e) => setEditProductForm((prev) => ({ ...prev, cost: e.target.value }))}
                fullWidth
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseEditProductDialog}
            className="button-variant-outlined"
            variant="outlined"

          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="button-variant-contained"
            onClick={() => {
              handleCloseEditProductDialog();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Snackbar */}
      <Snackbar
        open={successSnackbar.open}
        autoHideDuration={1500}
        onClose={() => setSuccessSnackbar({ open: false, message: '' })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSuccessSnackbar({ open: false, message: '' })}
          severity="success"
          sx={{ width: '100%' }}
        >
          {successSnackbar.message}
        </Alert>
      </Snackbar>

      <StandaloneManageColumnsModal
        show={isManageColumnsOpen}
        onHide={() => setIsManageColumnsOpen(false)}
        tableName="activeProductListColumns"
        columns={manageColumnsConfig}
        columnVisibility={columnVisibility}
        onColumnVisibilityChange={handleColumnVisibilityChange}
      />
    </>
  );
};
export default ActiveProductList;